import { render, staticRenderFns } from "./booklist.vue?vue&type=template&id=9a11f810&"
import script from "./booklist.vue?vue&type=script&lang=ts&"
export * from "./booklist.vue?vue&type=script&lang=ts&"
import style0 from "./booklist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports